import React, { Component } from "react";
import { connect } from "react-redux";
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import { exportProducts } from "../../redux/actions";
import moment from "moment";

class exportProductPriceInfoOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exportOption: "all",
            errorMessage: "",
            showDialog: false,
            allpricingChecked: false,
            allproductChecked: false,
            date: "",
            payload: {
                //PL
                //categoryId:'',
                //PN
                //keyword:'',
                //PN & PL
                //requestType:'',	//Set

                zip: "", //Set
                accountNumber: "", //Set
                priceOptions: ["Sales Agreement Number", "Sales Agreement Name", "Net Price"], //Set
                productOptions: ["Item Number", "Product Line"], //Set,
                todaysPrice: moment().format("MM/DD/YYYY"),
            },
            listItems: [],
            selectedListItems: [],
            allProductAndPricingInformation: {
                pricing: [
                    {
                        label: "Sales Agreement Number",
                        value: "Sales Agreement Number",
                        type: "salesAgreementNumber",
                        checked: true
                    },
                    {
                        label: "Sales Agreement Name",
                        value: "Sales Agreement Name",
                        type: "salesAgreementName",
                        checked: true
                    },
                    {
                        label: "MSRP",
                        value: "MSRP",
                        type: "price",
                        checked: false,
                    },
                    {
                        label: "MAP",
                        value: "MAP",
                        type: "price",
                        checked: false,
                    },
                    {
                        label: "Promo MAP",
                        value: "Promo MAP",
                        type: "price",
                        checked: false,
                    },
                    {
                        label: "Estimated Low Resell",
                        value: "Estimated Low Resell",
                        type: "price",
                        checked: false,
                    },
                    {
                        label: "List Price",
                        value: "List Price",
                        type: "price",
                        checked: false,
                    },
                    {
                        label: "All Price Details",
                        value: "All Price Details",
                        type: "discount",
                        checked: false,
                    },
                    {
                        label: "Net Price",
                        value: "Net Price",
                        type: "price",
                        checked: true,
                    }
                ],
                product: [
                    {
                        label: "Item Number",
                        value: "Item Number",
                        checked: true,
                        disabled: true
                    },
                    {
                        label: "UPC Code",
                        value: "UPC Code",
                        checked: false,
                    },
                    {
                        label: "Brand",
                        value: "Brand",
                        checked: false,
                    },
                    {
                        label: "Color",
                        value: "Color",
                        checked: false,
                    },
                    {
                        label: "Product Line",
                        value: "Product Line",
                        checked: true,
					    disabled: true
                    },
                    {
                        label: "Product Category",
                        value: "Product Category",
                        checked: false,
                    },
                    {
                        label: "Description",
                        value: "Description",
                        checked: false,
                    },
                    {
                        label: "ADA Compliant",
                        value: "ADA Compliant",
                        checked: false,
                    },
                    {
                        label: "Produced In America",
                        value: "Produced In America",
                        checked: false,
                    },
                    {
                        label: "EStar Qualified",
                        value: "EStar Qualified",
                        checked: false,
                    },
                    {
                        label: "Availability",
                        value: "Availability",
                        checked: false,
                    },
                    {
                        label: "Next Avail",
                        value: "Next Avail",
                        checked: false,
                    },
                    {
                        label: "ETA",
                        value: "ETA",
                        checked: false,
                    },
                    {
                        label: "Replacement Model",
                        value: "Replacement Model",
                        checked: false,
                    },
                    {
                        label: "Load Points",
                        value: "Load Points",
                        checked: false,
                    },
                    {
                        label: "Carton Dimensions",
                        value: "Carton Dimensions",
                        checked: false,
                    },
                    {
                        label: "Shipping Weight",
                        value: "Shipping Weight",
                        checked: false,
                    },
                     {
                        label: "Cabinet Width",
                        value: "Cabinet Width",
                        checked: false,
                    },
                    {
                        label: "Overall Height",
                        value: "Overall Height",
                        checked: false,
                    },
                      {
                        label: "Overall Width",
                        value: "Overall Width",
                        checked: false,
                    },
                    {
                        label: "Overall Depth",
                        value: "Overall Depth",
                        checked: false,
                    },
                ],
            },
        };
        // this.handleChange = this.handleChange.bind(this);
        this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
        // window.scrollTo(0, 0);
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false,
        });
        if (
            this.props.exportingFromWhere &&
            this.props.exportingFromWhere === "list"
        ) {
            this.props.handleDialog &&
                this.props.handleDialog("ExportProductPriceDialog", false);
        } else {
            this.props.handleDialogStatusExport(false, false);
        }
    }
    componentDidMount() {
        // window.scrollTo(0, 0);
        const listSku = [];
        const selectedSku = [];
        let payload = this.state.payload;
        if (
            this.props.exportingFromWhere &&
            this.props.exportingFromWhere === "list"
        ) {
            this.props.listItems &&
                this.props.listItems.length > 0 &&
                this.props.listItems.forEach((item, index) => {
                    listSku.push({ sku: item.item });
                });
            this.props.selectedListItems &&
                this.props.selectedListItems.length > 0 &&
                this.props.selectedListItems.forEach((item, index) => {
                    selectedSku.push({ sku: item.item });
                });
        } else {
            if (this.props.typeOfSearch === "quote-models") {
                const { productResultAvailability } = this.props.state.product;
                payload = {
                    ...payload,
                    sku: _.map(productResultAvailability, (item) => item.sku),
                };
            } else if (this.props.typeOfSearch === "product-number") {
                payload = {
                    ...payload,
                    keyword: this.props.searchKeyword + "*",
                };
            } else if (this.props.typeOfSearch === "product-line") {
                let categoryId = this.props.searchKeyword
                    .split("|")[1]
                    .replace("N=", "");
                const { productLineFilters } = this.props.state.product;
                if (productLineFilters && productLineFilters.selectedFilters) {
                    categoryId = productLineFilters.selectedFilters.map(
                        (item) => item.id
                    );
                    categoryId = categoryId.join("+");
                }
                payload = {
                    ...payload,
                    categoryId,
                };
            } else {
                payload = {
                    ...(this.props.payload || {}),
                    ...payload,
                };
            }
        }
        let pricing = this.state.allProductAndPricingInformation.pricing;
        if (this.props.typeOfAccount !== "RETAIL") {
            pricing = this.state.allProductAndPricingInformation.pricing.filter(
                (item) => item.value !== "All Price Details"
            );
        }
        this.setState({
            showDialog: this.props.showDialog,
            allProductAndPricingInformation: {
                ...this.state.allProductAndPricingInformation,
                pricing,
            },
            listItems: listSku,
            selectedListItems: selectedSku,
            payload,
        });
    }
    componentWillReceiveProps() {
        var pricing = [],
            payload = this.state.payload;
        if (this.props.isPricingAccess && this.props.isPriceDiscountAccess) {
            pricing = this.state.allProductAndPricingInformation.pricing;
            payload = {
                ...payload,
                requestType: "PriceDiscounts",
            };
        } else if (
            this.props.isPricingAccess &&
            !this.props.isPriceDiscountAccess
        ) {
            pricing = _.filter(
                this.state.allProductAndPricingInformation.pricing,
                ["type", "price"]
            );
            payload = {
                ...payload,
                requestType: "Price",
            };
        }
        this.setState({
            showDialog: this.props.showDialog,
            allProductAndPricingInformation: {
                ...this.state.allProductAndPricingInformation,
                pricing: pricing,
            },
            payload: payload,
        });
    }
    // handleChange(date) {
    //   	var self = this;
    //   	self.setState({
    // 	  	date: date,
    // 	  	payload: {
    // 		  	...self.state.payload,
    // 		  	futurePrice: date && date.format('MM/DD/YYYY')
    // 	  	}
    //   	});
    // }
    onChangeUpdateParam(paramName, event) {
        var self = this,
            paramValue = event.target.value;
        if (paramName === "todaysPrice") {
            if (event.target.checked) {
                paramValue = new Date();
                paramValue = moment().format("MM/DD/YYYY");
            } else {
                paramValue = "";
            }
        }
        self.setState({
            payload: {
                ...self.state.payload,
                [paramName]: paramValue,
            },
        });
    }
    handleAllCheckBox(whichObj, paramName, event) {
        var obj = this.state.allProductAndPricingInformation[whichObj],
            arrayList = [];
        obj.map((item, index) => {
            if (whichObj === "pricing") {
                if (
                    item.type === "discount" &&
                    !this.props.isPriceDiscountAccess
                )
                    return null;
                if (item.value === "MAP" && !this.props.isAccessToMAPGuidelines)
                    return null;
                if (
                    item.value === "Promo MAP" &&
                    !this.props.isAccessToMAPGuidelines
                )
                    return null;
            }
            if (item.disabled) {
                arrayList.push(item.value);
                return null;
            }
            item.checked = event.target.checked;
            if (event.target.checked) {
                arrayList.push(item.value);
            }
            return null;
        });
        this.setState({
            errorMessage: "",
            payload: {
                ...this.state.payload,
                [paramName]: arrayList,
            },
            allProductAndPricingInformation: {
                ...this.state.allProductAndPricingInformation,
                [whichObj]: obj,
            },
            ["all" + whichObj + "Checked"]: event.target.checked,
        });
    }
    handleSubcheckboxChange(whichObj, paramName, paramValue, event) {
        var obj = this.state.allProductAndPricingInformation[whichObj],
            arrayList = this.state.payload[paramName];
        obj.forEach((item, index) => {
            if (item.value === paramValue) {
                item.checked = event.target.checked;
                event.target.checked
                    ? arrayList.push(item.value)
                    : arrayList.splice(arrayList.indexOf(item.value), 1);
            }
        });
        this.setState({
            errorMessage: "",
            payload: {
                ...this.state.payload,
                [paramName]: arrayList,
            },
            allProductAndPricingInformation: {
                ...this.state.allProductAndPricingInformation,
                [whichObj]: obj,
            },
            ["all" + whichObj + "Checked"]: !event.target.checked
                ? false
                : this.state["all" + whichObj + "Checked"],
        });
    }
    handleExportInfo(event) {
        event.preventDefault();
        var self = this;
        self.setState({
            errorMessage: "",
        });
        //Check atlest one item is selected from price or product
        if (
            self.state.payload.priceOptions.length === 0 &&
            self.state.payload.productOptions.length === 0
        ) {
            self.setState({
                errorMessage:
                    "Please select at least one item from price or product.",
            });
        }
        //Check if date is selected in case of future check box is marked
        else if (
            self.futurePriceCheckbox &&
            self.futurePriceCheckbox.checked &&
            !self.state.payload.futurePrice
        ) {
            self.setState({
                errorMessage: "Please select future date.",
            });
        } else {
            let payload = self.state.payload;
            //remove priceoptions in case of not prices access from prepared payload
            if (!self.props.isPricingAccess) {
                delete payload.priceOptions;
            }
            //remove futurePrice in case of checkbox is not checked from prepared payload
            if (self.futurePriceCheckbox && !self.futurePriceCheckbox.checked) {
                delete payload.futurePrice;
            }
            //remove todays price if it is blank
            if (payload.todaysPrice === "") {
                delete payload.todaysPrice;
            }
            const { selectedAccount, userDetails, selectedPriceSource } =
                self.props.state.user;
            payload = {
                ...payload,
                accountNumber: selectedAccount.ACCOUNTNUMBER,
                salesAgreementNumber:
                    selectedPriceSource.AGREEMENT_NUMBER.toString(),
                salesAgreementName: 
                    selectedPriceSource.AGREEMENT_NAME,

                zip: self.props.getZipCode(),
                emailId: userDetails.email,
                userId: userDetails.sso,
            };
            //Remove because of timeout issue
            // dispatch(exportToExcel(payload, (response) => {
            // 	window.open(response.responseObject);
            // }))
            //check if exporting is happening from list, if it is list page then need to check whether all sku or selected sku needs to be send
            if (
                self.props.exportingFromWhere &&
                self.props.exportingFromWhere === "list"
            ) {
                self.setState({
                    errorExportOption: "",
                });
                if (self.state.exportOption === "selected") {
                    if (self.state.selectedListItems.length > 0) {
                        payload = {
                            ...payload,
                            sku: _.map(
                                this.state.selectedListItems,
                                (item) => item.sku
                            ),
                        };
                    } else {
                        self.setState({
                            errorExportOption:
                                "Please select at least one product",
                        });
                        return;
                    }
                } else if (self.state.exportOption === "all") {
                    if (self.state.listItems.length > 0) {
                        payload = {
                            ...payload,
                            sku: _.map(
                                this.state.listItems,
                                (item) => item.sku
                            ),
                        };
                    } else
                        self.setState({
                            errorExportOption:
                                "Please have at least one item in list",
                        });
                }
            }
            self.props.getOrgAttributesByAttributeName(
                "Top Load Indicator",
                (resp) => {
                    payload = {
                        ...payload,
                        topLoadIndicator: resp ? "Y" : "N",
                    };
                    const data = JSON.parse(
                        self.props.state.user.selectedAddress
                    );
                    const zipCode = data ? data.POSTALCODE.split("-")[0] : "";
                    zipCode &&
                        self.props.getShippingAddressesDetails(
                            zipCode,
                            false,
                            "adc_loc",
                            (resp) => {
                                if (resp && resp.agentid) {
                                    self.props.exportProducts(
                                        payload,
                                        `warehouseCode=${resp.agentid}`,
                                        (response) => {
                                            if (response.status) {
                                                if (
                                                    self.props
                                                        .exportingFromWhere &&
                                                    self.props
                                                        .exportingFromWhere ===
                                                        "list"
                                                )
                                                    self.props.handleDialog &&
                                                        self.props.handleDialog(
                                                            "ExportProductPriceDialog",
                                                            false,
                                                            true
                                                        );
                                                else
                                                    self.props.handleDialogStatusExport(
                                                        false,
                                                        true
                                                    );
                                            } else {
                                                self.setState({
                                                    errorMessage:
                                                        response.responseMessage,
                                                });
                                            }
                                        }
                                    );
                                }
                            }
                        );
                }
            );
        }
    }
    handleChangeExportOption(event) {
        this.setState({
            errorExportOption: "",
            exportOption: event.target.value,
        });
    }
    render() {
        return (
            <div
                className="overlayDialog"
                id="exportProductPriceInfoOverlayDialog"
                style={{
                    visibility:
                        this.state.showDialog === true ? "visible" : "hidden",
                }}
            >
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a
                        className="closeButton"
                        onClick={this.closeDialog.bind(this)}
                    >
                        ×
                    </a>
                    <h2 className="title">
                        Export Product &amp; Pricing Information
                    </h2>
                    <p className="red">
                        <strong>{this.state.errorMessage}</strong>
                    </p>
                    <form
                        className="exportProductPriceInfoForm"
                        name="exportProductPriceInfoForm"
                        action="exportProductPriceInfo"
                        method="POST"
                    >
                        {/* BEGIN OPTIONAL SECTION */}
                        {this.props.exportingFromWhere &&
                        this.props.exportingFromWhere === "list" ? (
                            <div className="priceDiv inline-datepicker-input">
                                <strong>Export</strong>
                                &nbsp;&nbsp;&nbsp;
                                <select
                                    onChange={this.handleChangeExportOption.bind(
                                        this
                                    )}
                                >
                                    <option value="all">
                                        All Products in List
                                    </option>
                                    <option value="selected">
                                        Only Selected Products
                                    </option>
                                </select>
                                &nbsp;{" "}
                                <span className="bold red">
                                    {this.state.errorExportOption}
                                </span>
                                <br />
                                <br />
                            </div>
                        ) : null}
                        {this.props.isPricingAccess ? (
                            <div className="priceDiv inline-datepicker-input">
                                <strong>Show</strong>
                                &nbsp;&nbsp;&nbsp;
                                <label>
                                    <input
                                        type="checkbox"
                                        defaultChecked={true}
                                        onChange={this.onChangeUpdateParam.bind(
                                            this,
                                            "todaysPrice"
                                        )}
                                        id="showTodaysPrice"
                                        name="showTodaysPrice"
                                        defaultValue="todaysPrice"
                                        disabled
                                    />{" "}
                                    Today&#39;s Price
                                </label>
                                {/* &nbsp;&nbsp;&nbsp;
				                <label><input type="checkbox" ref={(checkbx) => { this.futurePriceCheckbox = checkbx }} id="showFuturePrice" name="showFuturePrice" defaultValue="futurePrice" />Future Price</label>
				                &nbsp;&nbsp;&nbsp;<DatePicker minDate={moment()} maxDate={moment().add(60, "days")} placeholderText="Click to select a date" selected={this.state.date} onChange={this.handleChange} /> <var>(mm/dd/yyyy)</var>&nbsp;&nbsp;&nbsp;<i>(date must be within 60 days)</i>*/}
                            </div>
                        ) : null}
                        {/* END OPTIONAL SECTION */}
                        <p className="shaded">
                            Select the information to include in your export.
                        </p>
                        {this.props.isPricingAccess ? (
                            <div className="push">
                                <p className="checkboxParagraph allPriceInformation">
                                    <input
                                        checked={this.state.allpricingChecked}
                                        onChange={this.handleAllCheckBox.bind(
                                            this,
                                            "pricing",
                                            "priceOptions"
                                        )}
                                        className="selectAllCheckbox"
                                        type="checkbox"
                                        name="priceInfoToExport"
                                        id="priceInfoToExport_all"
                                        defaultValue="all"
                                    />
                                    <label htmlFor="priceInfoToExport_all">
                                        All Price Information
                                    </label>
                                </p>
                                {this.state.allProductAndPricingInformation.pricing.map(
                                    (item, index) => {
                                        if (
                                            item.type === "discount" &&
                                            !this.props.isPriceDiscountAccess
                                        )
                                            return null;
                                        if (
                                            item.value === "MAP" &&
                                            !this.props.isAccessToMAPGuidelines
                                        )
                                            return null;
                                        if (
                                            item.value === "Promo MAP" &&
                                            !this.props.isAccessToMAPGuidelines
                                        )
                                            return null;
                                        return (
                                            <p
                                                key={index}
                                                className="checkboxParagraph individualOption priceInformation"
                                            >
                                                <input
                                                    type="checkbox"
                                                    onChange={this.handleSubcheckboxChange.bind(
                                                        this,
                                                        "pricing",
                                                        "priceOptions",
                                                        item.value
                                                    )}
                                                    checked={item.checked}
                                                    disabled={item.disabled}
                                                    name="priceInfoToExport"
                                                    id={
                                                        "priceInfoToExport" +
                                                        index
                                                    }
                                                    defaultValue={item.value}
                                                />
                                                <label
                                                    htmlFor={
                                                        "priceInfoToExport" +
                                                        index
                                                    }
                                                >
                                                    {item.label}
                                                </label>
                                            </p>
                                        );
                                    }
                                )}
                            </div>
                        ) : null}
                        <div id="productInformationDiv">
                            <p className="checkboxParagraph allProductInformation">
                                <input
                                    checked={this.state.allproductChecked}
                                    onChange={this.handleAllCheckBox.bind(
                                        this,
                                        "product",
                                        "productOptions"
                                    )}
                                    className="selectAllCheckbox"
                                    type="checkbox"
                                    name="productInfoToExport"
                                    id="productInfoToExport_all"
                                    defaultValue="all"
                                />
                                <label htmlFor="productInfoToExport_all">
                                    All Product Information
                                </label>
                            </p>
                            {this.state.allProductAndPricingInformation.product.map(
                                (item, index) => {
                                    return (
                                        <p
                                            key={index}
                                            className="checkboxParagraph individualOption productInformation"
                                        >
                                            <input
                                                type="checkbox"
                                                onChange={this.handleSubcheckboxChange.bind(
                                                    this,
                                                    "product",
                                                    "productOptions",
                                                    item.value
                                                )}
                                                checked={item.checked}
                                                disabled={item.disabled}
                                                name="productInfoToExport"
                                                id={
                                                    "productInfoToExport" +
                                                    index
                                                }
                                                defaultValue={item.value}
                                            />
                                            <label
                                                htmlFor={
                                                    "productInfoToExport" +
                                                    index
                                                }
                                            >
                                                {item.label}
                                            </label>
                                        </p>
                                    );
                                }
                            )}
                        </div>
                        <div className="noButtonContainer">
                            <a
                                onClick={this.closeDialog.bind(this)}
                                href=""
                                className="noButton blueButton"
                            >
                                Cancel
                            </a>
                        </div>
                        <div className="yesButtonContainer">
                            <input
                                className="yesButton blueButton"
                                onClick={this.handleExportInfo.bind(this)}
                                type="submit"
                                id="exportInformation"
                                defaultValue="Export Information"
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { state };
};

const mapDispatchToProps = (dispatch) => ({
    exportProducts: (payload, queryStringParams, callback) =>
        dispatch(exportProducts(payload, queryStringParams, callback)),
});

exportProductPriceInfoOverlayDialog = connect(
    mapStateToProps,
    mapDispatchToProps
)(exportProductPriceInfoOverlayDialog);
export default exportProductPriceInfoOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/exportProductPriceInfoOverlayDialog.js